var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"border-white inline-block border-2 rounded-full h-24 w-24 animate-bubble",staticStyle:{"transform":"scale(0)"}})}
var staticRenderFns = []

export { render, staticRenderFns }